import { DeleteModal } from './delete-modal';

export { DeleteModal };
